import React from 'react'
import PropTypes from 'prop-types'
import { Box } from '@maui/elements'
import { add } from 'date-fns'
import { DateInput } from '@maui/react-day-picker'

const DateSelector = ({ children, ...props }) => {
  const { date, onComplete, inputProps, clearDate, ...rest } = props
  const handleOnComplete = (date) => {
    if (!date) {
      clearDate()
      return
    }
    onComplete(date)
  }
  return (
    <DateInput
      dayPickerProps={date && {
        fromDate: add(new Date(), { days: 1 }),
        toDate: add(new Date(), { years: 1 }),
      }}
      date={date}
      onComplete={handleOnComplete}
      inputProps={inputProps}
      {...rest}
    >
      {children}
    </DateInput>
  )
}

export default function FormDatePicker({ state, dispatch }) {
  return (
    <Box
      width="50%"
    >
      <DateSelector
        date={state.preferred_delivery_date.value}
        onComplete={(date) =>
          dispatch({ type: 'updateField', payload: { name: 'preferred_delivery_date', value: new Date(date) } })
        }
        inputProps={{
          placeholder: 'Select a date...',
          width: '100%',
          cursor: 'pointer',
          name: 'preferred_delivery_date',
          id: 'preferred_delivery_date',
          autoComplete: 'off',
        }}
      />
    </Box>
  )
}

FormDatePicker.propTypes = {
  state: PropTypes.object,
  dispatch: PropTypes.func
}
